// node_modules/effector/effector.mjs
function e(e2, t2) {
  for (let r2 in e2)
    t2(e2[r2], r2);
}
function t(e2, t2) {
  e2.forEach(t2);
}
function r(e2, t2) {
  if (!e2)
    throw Error(t2);
}
function n(e2, t2) {
  ce = { parent: ce, value: e2, template: G(e2, "template") || pe(), sidRoot: G(e2, "sidRoot") || ce && ce.sidRoot };
  try {
    return t2();
  } finally {
    ce = H(ce);
  }
}
function a({ node: e2 = [], from: r2, source: n2, parent: a2 = r2 || n2, to: i2, target: o2, child: l2 = i2 || o2, scope: s2 = {}, meta: f2 = {}, family: u2 = { type: "regular" }, regional: d2 } = {}) {
  let c2 = ye(a2), p2 = ye(u2.links), m2 = ye(u2.owners), g2 = [];
  t(e2, (e3) => e3 && oe(g2, e3));
  let h2 = { id: de(), seq: g2, next: ye(l2), meta: f2, scope: s2, family: { type: u2.type || "crosslink", links: p2, owners: m2 } };
  return t(p2, (e3) => oe(V(e3), h2)), t(m2, (e3) => oe(L(e3), h2)), t(c2, (e3) => oe(e3.next, h2)), d2 && ce && he(B(ce), [h2]), h2;
}
function i(e2, r2, n2) {
  let a2 = Ze, i2 = null, o2 = Ke;
  if (e2.target && (r2 = e2.params, n2 = e2.defer, a2 = "page" in e2 ? e2.page : a2, e2.stack && (i2 = e2.stack), o2 = U(e2) || o2, e2 = e2.target), o2 && Ke && o2 !== Ke && (Ke = null), Array.isArray(e2))
    for (let t2 = 0; t2 < e2.length; t2++)
      He("pure", a2, _(e2[t2]), i2, r2[t2], o2);
  else
    He("pure", a2, _(e2), i2, r2, o2);
  if (n2 && !Qe)
    return;
  let l2, s2, f2, u2, d2, c2, p2 = { isRoot: Qe, currentPage: Ze, scope: Ke, isWatch: Xe, isPure: Ye };
  Qe = 0;
  e:
    for (; u2 = We(); ) {
      let { idx: e3, stack: r3, type: n3 } = u2;
      f2 = r3.node, Ze = d2 = r3.page, Ke = U(r3), d2 ? c2 = d2.reg : Ke && (c2 = Ke.reg);
      let a3 = !!d2, i3 = !!Ke, o3 = { fail: 0, scope: f2.scope };
      l2 = s2 = 0;
      for (let t2 = e3; t2 < f2.seq.length && !l2; t2++) {
        let u3 = f2.seq[t2];
        if (u3.order) {
          let { priority: a4, barrierID: i4 } = u3.order, o4 = i4 ? d2 ? `${d2.fullID}_${i4}` : i4 : 0;
          if (t2 !== e3 || n3 !== a4) {
            i4 ? Je.has(o4) || (Je.add(o4), Ue(t2, r3, a4, i4)) : Ue(t2, r3, a4);
            continue e;
          }
          i4 && Je.delete(o4);
        }
        switch (u3.type) {
          case "mov": {
            let e5, t3 = u3.data;
            switch (t3.from) {
              case P:
                e5 = B(r3);
                break;
              case "a":
              case "b":
                e5 = r3[t3.from];
                break;
              case "value":
                e5 = t3.store;
                break;
              case "store":
                if (c2 && !c2[t3.store.id])
                  if (a3) {
                    let e6 = rt(d2, t3.store.id);
                    r3.page = d2 = e6, e6 ? c2 = e6.reg : i3 ? (ot(Ke, t3.store, 0, 1, t3.softRead), c2 = Ke.reg) : c2 = void 0;
                  } else
                    i3 && ot(Ke, t3.store, 0, 1, t3.softRead);
                e5 = Pe(c2 && c2[t3.store.id] || t3.store);
            }
            switch (t3.to) {
              case P:
                r3.value = e5;
                break;
              case "a":
              case "b":
                r3[t3.to] = e5;
                break;
              case "store":
                nt(d2, Ke, f2, t3.target).current = e5;
            }
            break;
          }
          case "compute":
            let e4 = u3.data;
            if (e4.fn) {
              Xe = "watch" === G(f2, "op"), Ye = e4.pure;
              let t3 = e4.safe ? (0, e4.fn)(B(r3), o3.scope, r3) : lt(o3, e4.fn, r3);
              e4.filter ? s2 = !t3 : r3.value = t3, Xe = p2.isWatch, Ye = p2.isPure;
            }
        }
        l2 = o3.fail || s2;
      }
      if (!l2) {
        let e4 = B(r3), n4 = U(r3);
        if (t(f2.next, (t2) => {
          He("child", d2, t2, r3, e4, n4);
        }), n4) {
          G(f2, "needFxCounter") && He("child", d2, n4.fxCount, r3, e4, n4), G(f2, "storeChange") && He("child", d2, n4.storeChange, r3, e4, n4), G(f2, "warnSerialize") && He("child", d2, n4.warnSerializeNode, r3, e4, n4);
          let a4 = n4.additionalLinks[f2.id];
          a4 && t(a4, (t2) => {
            He("child", d2, t2, r3, e4, n4);
          });
        }
      }
    }
  Qe = p2.isRoot, Ze = p2.currentPage, Ke = U(p2);
}
function o(t2, r2 = "combine") {
  let n2 = r2 + "(", a2 = "", i2 = 0;
  return e(t2, (e2) => {
    i2 < 25 && (null != e2 && (n2 += a2, n2 += Q(e2) ? K(e2).fullName : e2.toString()), i2 += 1, a2 = ", ");
  }), n2 + ")";
}
function l(e2, t2) {
  e2.shortName = t2, Object.assign(K(e2), s(t2, H(e2)));
}
function s(e2, t2) {
  let r2, n2, a2 = e2;
  if (t2) {
    let a3 = K(t2);
    0 === e2.length ? (r2 = a3.path, n2 = a3.fullName) : (r2 = a3.path.concat([e2]), n2 = 0 === a3.fullName.length ? e2 : a3.fullName + "/" + e2);
  } else
    r2 = 0 === e2.length ? [] : [e2], n2 = e2;
  return { shortName: a2, fullName: n2, path: r2 };
}
function f(e2, t2) {
  let r2 = t2 ? e2 : e2[0];
  we(r2);
  let n2 = r2.or, a2 = r2.and;
  if (a2) {
    let r3 = t2 ? a2 : a2[0];
    if (be(r3) && "and" in r3) {
      let r4 = f(a2, t2);
      e2 = r4[0], n2 = { ...n2, ...r4[1] };
    } else
      e2 = a2;
  }
  return [e2, n2];
}
function u(e2, ...t2) {
  let r2 = pe();
  if (r2) {
    let n2 = r2.handlers[e2];
    if (n2)
      return n2(r2, ...t2);
  }
}
function d(e2, t2) {
  let r2 = st({ or: t2, and: "string" == typeof e2 ? { name: e2 } : e2 }), n2 = (e3, ...t3) => (le(!G(n2, "derived"), "call of derived event", "createEvent"), le(!Ye, "unit call from pure function", "operators like sample"), Ze ? ((e4, t4, r3, n3) => {
    let a2 = Ze, i2 = null;
    if (t4)
      for (i2 = Ze; i2 && i2.template !== t4; )
        i2 = H(i2);
    tt(i2);
    let o3 = e4.create(r3, n3);
    return tt(a2), o3;
  })(n2, o2, e3, t3) : n2.create(e3, t3)), o2 = pe(), l2 = Object.assign(n2, { graphite: a({ meta: bt("event", n2, r2), regional: 1 }), create: (e3) => (i({ target: n2, params: e3, scope: Ke }), e3), watch: (e3) => ht(n2, e3), map: (e3) => vt(n2, R, e3, [De()]), filter: (e3) => vt(n2, "filter", e3.fn ? e3 : e3.fn, [De(Ce, 1)]), filterMap: (e3) => vt(n2, "filterMap", e3, [De(), Oe((e4) => !ke(e4), 1)]), prepend(e3) {
    let t3 = d("* \u2192 " + n2.shortName, { parent: H(n2) });
    return u("eventPrepend", _(t3)), mt(t3, n2, [De()], "prepend", e3), yt(n2, t3), t3;
  } });
  return null != r2 && r2.domain && r2.domain.hooks.event(l2), l2;
}
function c(e2, n2) {
  let o2 = st(n2), l2 = Re(e2), s2 = d({ named: "updates", derived: 1 });
  u("storeBase", l2);
  let f2 = l2.id, p2 = { subscribers: /* @__PURE__ */ new Map(), updates: s2, defaultState: e2, stateRef: l2, getState() {
    let e3, t2 = l2;
    if (Ze) {
      let t3 = Ze;
      for (; t3 && !t3.reg[f2]; )
        t3 = H(t3);
      t3 && (e3 = t3);
    }
    return !e3 && Ke && (ot(Ke, l2, 1), e3 = Ke), e3 && (t2 = e3.reg[f2]), Pe(t2);
  }, setState: (e3) => i({ target: p2, params: e3, defer: 1, scope: Ke }), reset: (...e3) => (t(e3, (e4) => p2.on(e4, () => p2.defaultState)), p2), on: (e3, n3) => (xe(e3, ".on", "first argument"), r(ve(n3), "second argument should be a function"), le(!G(p2, "derived"), ".on in derived store", "createStore"), t(Array.isArray(e3) ? e3 : [e3], (e4) => {
    p2.off(e4), W(p2).set(e4, pt(kt(e4, p2, "on", je, n3)));
  }), p2), off(e3) {
    let t2 = W(p2).get(e3);
    return t2 && (t2(), W(p2).delete(e3)), p2;
  }, map(e3, t2) {
    let r2, n3;
    be(e3) && (r2 = e3, e3 = e3.fn), le(ke(t2), "second argument of store.map", "updateFilter");
    let a2 = p2.getState();
    pe() ? n3 = null : ke(a2) || (n3 = e3(a2, t2));
    let i2 = c(n3, { name: `${p2.shortName} \u2192 *`, derived: 1, and: r2 }), o3 = kt(p2, i2, R, Me, e3);
    return _e(T(i2), { type: R, fn: e3, from: l2 }), T(i2).noInit = 1, u("storeMap", l2, o3), i2;
  }, watch(e3, t2) {
    if (!t2 || !Q(e3)) {
      let t3 = ht(p2, e3);
      return u("storeWatch", l2, e3) || e3(p2.getState()), t3;
    }
    return r(ve(t2), "second argument should be a function"), e3.watch((e4) => t2(p2.getState(), e4));
  } }, m2 = bt("store", p2, o2), g2 = p2.defaultConfig.updateFilter;
  p2.graphite = a({ scope: { state: l2, fn: g2 }, node: [Oe((e3, t2, r2) => (r2.scope && !r2.scope.reg[l2.id] && (r2.b = 1), e3)), Fe(l2), Oe((e3, t2, { a: r2, b: n3 }) => !ke(e3) && (e3 !== r2 || n3), 1), g2 && De(Me, 1), Ie({ from: P, target: l2 })], child: s2, meta: m2, regional: 1 });
  let h2 = G(p2, "serialize"), y2 = G(p2, "derived"), b2 = "ignore" === h2, v2 = !h2 || b2 ? 0 : h2, k2 = G(p2, "sid");
  return k2 && (b2 || J(p2, "storeChange", 1), l2.sid = k2, v2 && (l2.meta = { ...null == l2 ? void 0 : l2.meta, serialize: v2 })), k2 || b2 || y2 || J(p2, "warnSerialize", 1), r(y2 || !ke(e2), "current state can't be undefined, use null instead"), he(p2, [s2]), null != o2 && o2.domain && o2.domain.hooks.store(p2), y2 || (p2.reinit = d(), p2.reset(p2.reinit)), p2;
}
function p(...e2) {
  let t2, n2, a2;
  [e2, a2] = f(e2);
  let i2, o2, l2, s2 = e2[e2.length - 1];
  if (ve(s2) ? (n2 = e2.slice(0, -1), t2 = s2) : n2 = e2, 1 === n2.length) {
    let e3 = n2[0];
    Y(e3) || (i2 = e3, o2 = 1);
  }
  if (!o2 && (i2 = n2, t2)) {
    l2 = 1;
    let e3 = t2;
    t2 = (t3) => e3(...t3);
  }
  return r(be(i2), "shape should be an object"), wt(Array.isArray(i2), !l2, i2, a2, t2);
}
function m(...e2) {
  return le(0, "createStoreObject", "combine"), p(...e2);
}
function g() {
  let e2 = {};
  return e2.req = new Promise((t2, r2) => {
    e2.rs = t2, e2.rj = r2;
  }), e2.req.catch(() => {
  }), e2;
}
function h(e2, t2) {
  let n2 = st(ve(e2) ? { handler: e2 } : e2, t2), o2 = d(ve(e2) ? { handler: e2 } : e2, t2), l2 = _(o2);
  J(l2, "op", o2.kind = "effect"), o2.use = (e3) => (r(ve(e3), ".use argument should be a function"), h2.scope.handler = e3, o2), o2.use.getCurrent = () => h2.scope.handler;
  let s2 = o2.finally = d({ named: "finally", derived: 1 }), f2 = o2.done = s2.filterMap({ named: "done", fn({ status: e3, params: t3, result: r2 }) {
    if ("done" === e3)
      return { params: t3, result: r2 };
  } }), u2 = o2.fail = s2.filterMap({ named: "fail", fn({ status: e3, params: t3, error: r2 }) {
    if ("fail" === e3)
      return { params: t3, error: r2 };
  } }), p2 = o2.doneData = f2.map({ named: "doneData", fn: ({ result: e3 }) => e3 }), m2 = o2.failData = u2.map({ named: "failData", fn: ({ error: e3 }) => e3 }), h2 = a({ scope: { handlerId: G(l2, "sid"), handler: o2.defaultConfig.handler || (() => r(0, `no handler used in ${o2.getType()}`)) }, node: [Oe((e3, t3, r2) => {
    let n3 = t3, a2 = n3.handler;
    if (U(r2)) {
      let e4 = U(r2).handlers[n3.handlerId];
      e4 && (a2 = e4);
    }
    return e3.handler = a2, e3;
  }, 0, 1), Oe(({ params: e3, req: t3, handler: r2, args: n3 = [e3] }, a2, i2) => {
    let o3 = xt(i2), l3 = zt(e3, t3, 1, s2, i2, o3), f3 = zt(e3, t3, 0, s2, i2, o3), [u3, d2] = St(r2, f3, n3);
    u3 && (be(d2) && ve(d2.then) ? d2.then(l3, f3) : l3(d2));
  }, 0, 1)], meta: { op: "fx", fx: "runner" } });
  l2.scope.runner = h2, oe(l2.seq, Oe((e3, { runner: t3 }, r2) => {
    let n3 = H(r2) ? { params: e3, req: { rs(e4) {
    }, rj(e4) {
    } } } : e3;
    return i({ target: t3, params: n3, defer: 1, scope: U(r2) }), n3.params;
  }, 0, 1)), o2.create = (e3) => {
    let t3 = g(), r2 = { params: e3, req: t3 };
    if (Ke) {
      if (!Xe) {
        let e4 = Ke;
        t3.req.finally(() => {
          et(e4);
        }).catch(() => {
        });
      }
      i({ target: o2, params: r2, scope: Ke });
    } else
      i(o2, r2);
    return t3.req;
  };
  let y2 = o2.inFlight = c(0, { serialize: "ignore" }).on(o2, (e3) => e3 + 1).on(s2, (e3) => e3 - 1).map({ fn: (e3) => e3, named: "inFlight" });
  J(s2, "needFxCounter", "dec"), J(o2, "needFxCounter", 1);
  let b2 = o2.pending = y2.map({ fn: (e3) => e3 > 0, named: "pending" });
  return he(o2, [s2, f2, u2, p2, m2, b2, y2]), null != n2 && n2.domain && n2.domain.hooks.effect(o2), o2;
}
function y(e2) {
  let t2;
  [e2, t2] = f(e2, 1);
  let { source: r2, effect: n2, mapParams: a2 } = e2, o2 = h(e2, t2);
  J(o2, "attached", 1);
  let l2, { runner: u2 } = _(o2).scope, d2 = Oe((e3, t3, n3) => {
    let l3, { params: s2, req: f2, handler: u3 } = e3, d3 = o2.finally, c3 = xt(n3), p2 = zt(s2, f2, 0, d3, n3, c3), m2 = n3.a, g2 = ee(u3), h2 = 1;
    if (a2 ? [h2, l3] = St(a2, p2, [s2, m2]) : l3 = r2 && g2 ? m2 : s2, h2) {
      if (!g2)
        return e3.args = [m2, l3], 1;
      i({ target: u3, params: { params: l3, req: { rs: zt(s2, f2, 1, d3, n3, c3), rj: p2 } }, page: n3.page, defer: 1 });
    }
  }, 1, 1);
  if (r2) {
    let e3;
    Y(r2) ? (e3 = r2, he(e3, [o2])) : (e3 = p(r2), he(o2, [e3])), l2 = [Fe(T(e3)), d2];
  } else
    l2 = [d2];
  u2.seq.splice(1, 0, ...l2), o2.use(n2);
  let c2 = H(n2);
  return c2 && (Object.assign(K(o2), s(o2.shortName, c2)), o2.defaultConfig.parent = c2), yt(n2, o2, "effect"), o2;
}
function b(...t2) {
  let [[r2, n2], a2] = f(t2), i2 = {};
  return e(n2, (e2, t3) => {
    let n3 = i2[t3] = d(t3, { parent: H(r2), config: a2 });
    r2.on(n3, e2), yt(r2, n3);
  }), i2;
}
function v(r2, n2) {
  let o2 = st({ or: n2, and: "string" == typeof r2 ? { name: r2 } : r2 }), l2 = a({ family: { type: "domain" }, regional: 1, parent: (null == o2 ? void 0 : o2.domain) || (null == o2 ? void 0 : o2.parent) }), s2 = { history: {}, graphite: l2, hooks: {} };
  l2.meta = bt("domain", s2, { parent: (null == o2 ? void 0 : o2.domain) || (null == o2 ? void 0 : o2.parent), or: o2 }), e({ Event: d, Effect: h, Store: c, Domain: v }, (e2, r3) => {
    let n3 = r3.toLowerCase(), a2 = d({ named: `on${r3}` });
    s2.hooks[n3] = a2;
    let o3 = /* @__PURE__ */ new Set();
    s2.history[`${n3}s`] = o3, a2.create = (e3) => (i(a2, e3), e3), oe(_(a2).seq, Oe((e3, t2, r4) => (r4.scope = null, e3))), a2.watch((e3) => {
      he(s2, [e3]), o3.add(e3), e3.ownerSet || (e3.ownerSet = o3), H(e3) || (e3.parent = s2);
    }), he(s2, [a2]), s2[`onCreate${r3}`] = (e3) => (t(o3, e3), a2.watch(e3)), s2[`create${r3}`] = s2[n3] = (t2, r4) => {
      let n4 = st({ and: r4, or: t2 });
      return null != n4 && n4.domain ? e2(t2, r4) : a2(e2(t2, { parent: s2, or: n4 }));
    };
  });
  let f2 = H(s2);
  return f2 && e(s2.hooks, (e2, t2) => mt(e2, f2.hooks[t2])), null != o2 && o2.domain && o2.domain.hooks.domain(s2), s2;
}
function k(e2) {
  we(e2);
  let t2 = E in e2 ? e2[E]() : e2;
  r(t2.subscribe, "expect observable to have .subscribe");
  let n2 = d(), a2 = pt(n2);
  return t2.subscribe({ next: n2, error: a2, complete: a2 }), n2;
}
function w(e2, t2) {
  xe(e2, "merge", "first argument");
  let r2 = d({ name: o(e2, "merge"), derived: 1, and: t2 });
  return mt(e2, r2, [], "merge"), r2;
}
function S(e2, n2) {
  let a2 = 0;
  return t(jt, (t2) => {
    t2 in e2 && (r(null != e2[t2], Ct(n2, t2)), a2 = 1);
  }), a2;
}
function x(...e2) {
  let t2, r2, n2, a2, [[i2, o2, l2], s2] = f(e2), u2 = 1;
  return ke(o2) && be(i2) && S(i2, "sample") && (o2 = i2.clock, l2 = i2.fn, u2 = !i2.greedy, a2 = i2.filter, t2 = i2.target, r2 = i2.name, n2 = i2.sid, i2 = i2.source), $t("sample", o2, i2, a2, t2, l2, r2, s2, u2, 1, 0, n2);
}
function z(...e2) {
  let [[t2, r2], n2] = f(e2);
  return r2 || (r2 = t2, t2 = r2.source), S(r2, "guard"), $t("guard", r2.clock, t2, r2.filter, r2.target, null, r2.name, n2, !r2.greedy, 0, 1);
}
function M(t2, r2, n2) {
  if (Y(t2))
    return le(0, "restore($store)"), t2;
  if (Z(t2) || ee(t2)) {
    let e2 = H(t2), a3 = c(r2, { parent: e2, name: t2.shortName, and: n2 });
    return mt(ee(t2) ? t2.doneData : t2, a3), e2 && e2.hooks.store(a3), a3;
  }
  let a2 = Array.isArray(t2) ? [] : {};
  return e(t2, (e2, t3) => a2[t3] = Y(e2) ? e2 : c(e2, { name: t3 })), a2;
}
function j(...t2) {
  let n2, i2, o2 = "split", [[l2, s2], c2] = f(t2), p2 = !s2;
  p2 && (n2 = l2.cases, s2 = l2.match, i2 = l2.clock, l2 = l2.source);
  let m2 = Y(s2), g2 = !Q(s2) && ve(s2), h2 = !m2 && !g2 && be(s2);
  n2 || (n2 = {}), p2 ? e(n2, (e2, t3) => ze(o2, e2, `cases.${t3}`)) : (r(h2, "match should be an object"), e(s2, (e2, t3) => n2[t3] = d({ derived: 1, and: c2 })), n2.__ = d({ derived: 1, and: c2 }));
  let y2, b2 = new Set([].concat(l2, i2 || [], Object.values(n2))), v2 = Object.keys(m2 || g2 ? n2 : s2);
  if (m2 || g2)
    m2 && b2.add(s2), y2 = [m2 && Fe(T(s2), 0, 1), qe({ safe: m2, filter: 1, pure: !m2, fn(e2, t3, r2) {
      let n3 = String(m2 ? r2.a : s2(e2));
      qt(t3, ae(v2, n3) ? n3 : "__", e2, r2);
    } })];
  else if (h2) {
    let t3 = Re({});
    t3.type = "shape";
    let r2, n3 = [];
    e(s2, (e2, a2) => {
      if (Q(e2)) {
        r2 = 1, oe(n3, a2), b2.add(e2);
        let i3 = mt(e2, [], [Fe(t3), Oe((e3, t4, { a: r3 }) => r3[a2] = e3)]);
        if (Y(e2)) {
          t3.current[a2] = e2.getState();
          let r3 = T(e2);
          _e(t3, { from: r3, field: a2, type: "field" }), u("splitMatchStore", r3, i3);
        }
      }
    }), r2 && u("splitBase", t3), y2 = [r2 && Fe(t3, 0, 1), De((e2, t4, r3) => {
      for (let a2 = 0; a2 < v2.length; a2++) {
        let i3 = v2[a2];
        if (ae(n3, i3) ? r3.a[i3] : s2[i3](e2))
          return void qt(t4, i3, e2, r3);
      }
      qt(t4, "__", e2, r3);
    }, 1)];
  } else
    r(0, "expect match to be unit, function or object");
  let k2 = a({ meta: { op: o2 }, parent: i2 ? [] : l2, scope: n2, node: y2, family: { owners: Array.from(b2) }, regional: 1 });
  if (i2 && $t(o2, i2, l2, null, k2, null, o2, c2, 0, 0, 0), !p2)
    return n2;
}
function C(e2, { scope: t2, params: r2 }) {
  if (!Q(e2))
    return Promise.reject(new Error("first argument should be unit"));
  if (!ee(e2) && !Z(e2) && !Y(e2))
    return Promise.reject(new Error("first argument accepts only effects, events and stores"));
  let n2 = g();
  n2.parentFork = Ke;
  let { fxCount: a2 } = t2;
  oe(a2.scope.defers, n2);
  let o2 = [e2], l2 = [];
  return oe(l2, ee(e2) ? { params: r2, req: { rs(e3) {
    n2.value = { status: "done", value: e3 };
  }, rj(e3) {
    n2.value = { status: "fail", value: e3 };
  } } } : r2), oe(o2, a2), oe(l2, null), i({ target: o2, params: l2, scope: t2 }), n2.req;
}
function $(e2, r2) {
  let n2 = [];
  (function e3(a2) {
    ae(n2, a2) || (oe(n2, a2), "store" === G(a2, "op") && G(a2, "sid") && r2(a2, G(a2, "sid")), t(a2.next, e3), t(V(a2), e3), t(L(a2), e3));
  })(e2);
}
function A(e2, n2) {
  let a2 = Array.isArray(e2) ? new Map(e2) : e2;
  if (a2 instanceof Map) {
    let e3 = {};
    return t(a2, (t2, a3) => {
      r(Q(a3), "Map key should be a unit"), n2 && n2(a3, t2), r(a3.sid, "unit should have a sid"), r(!(a3.sid in e3), "duplicate sid found"), e3[a3.sid] = t2;
    }), e3;
  }
  return a2;
}
function I(e2, n2) {
  let i2, o2 = e2;
  te(e2) && (i2 = e2, o2 = n2);
  let l2 = ((e3) => {
    let r2 = a({ scope: { defers: [], inFlight: 0, fxID: 0 }, node: [Oe((e4, t2, r3) => {
      H(r3) ? "dec" === G(H(r3).node, "needFxCounter") ? t2.inFlight -= 1 : (t2.inFlight += 1, t2.fxID += 1) : t2.fxID += 1;
    }), qe({ priority: "sampler", batch: 1 }), Oe((e4, r3) => {
      let { defers: n4, fxID: a2 } = r3;
      r3.inFlight > 0 || 0 === n4.length || Promise.resolve().then(() => {
        r3.fxID === a2 && t(n4.splice(0, n4.length), (e5) => {
          et(e5.parentFork), e5.rs(e5.value);
        });
      });
    }, 0, 1)] }), n3 = a({ node: [Oe((e4, t2, r3) => {
      let n4 = H(r3);
      if (n4) {
        let t3 = n4.node;
        if (!G(t3, "isCombine") || H(n4) && "combine" !== G(H(n4).node, "op")) {
          let n5 = U(r3), a2 = t3.scope.state.id, i4 = G(t3, "sid");
          n5.sidIdMap[i4] = a2, n5.sidValuesMap[i4] = e4;
          let o4 = G(t3, "serialize");
          o4 && "ignore" !== o4 && (n5.sidSerializeMap[i4] = o4.write);
        }
      }
    })] }), i3 = a({ node: [Oe((e4, t2, r3) => {
      let n4 = U(r3);
      if (n4) {
        let e5 = H(r3);
        e5 && (!G(e5.node, "isCombine") || H(e5) && "combine" !== G(H(e5).node, "op")) && (n4.warnSerialize = 1);
      }
    })] }), o3 = { cloneOf: e3, reg: {}, sidValuesMap: {}, sidIdMap: {}, sidSerializeMap: {}, getState(e4) {
      if ("current" in e4)
        return nt(Ze, o3, null, e4).current;
      let t2 = _(e4);
      return nt(Ze, o3, t2, t2.scope.state, 1).current;
    }, kind: "scope", graphite: a({ family: { type: "domain", links: [r2, n3, i3] }, meta: { unit: "fork" }, scope: { forkInFlightCounter: r2 } }), additionalLinks: {}, handlers: {}, fxCount: r2, storeChange: n3, warnSerializeNode: i3, activeEffects: [] };
    return o3;
  })(i2);
  if (o2) {
    let e3 = o2.scope;
    if (e3) {
      let r2 = e3.activeEffects;
      e3.activeEffects = [], l2.activeEffects = r2, t(r2, (e4) => e4.ref = l2);
    }
    if (o2.values) {
      let e4 = A(o2.values, (e5) => r(Y(e5), "Values map can contain only stores as keys"));
      Object.assign(l2.sidValuesMap, e4), l2.fromSerialize = !(Array.isArray(o2.values) || o2.values instanceof Map);
    }
    o2.handlers && (l2.handlers = A(o2.handlers, (e4) => r(ee(e4), "Handlers map can contain only effects as keys")));
  }
  return l2;
}
function q(e2, { values: t2 }) {
  r(be(t2), "values property should be an object");
  let n2, a2, o2, l2 = A(t2), s2 = Object.getOwnPropertyNames(l2), f2 = [], u2 = [];
  re(e2) ? (n2 = e2, o2 = 1, r(n2.cloneOf, "scope should be created from domain"), a2 = _(n2.cloneOf)) : te(e2) ? a2 = _(e2) : r(0, "first argument of hydrate should be domain or scope"), $(a2, (e3, t3) => {
    if (ae(s2, t3)) {
      oe(f2, e3);
      let r2 = G(e3, "serialize");
      r2 && "ignore" !== r2 && (l2[t3] = r2.read(l2[t3])), oe(u2, l2[t3]);
    }
  }), i({ target: f2, params: u2, scope: n2 }), o2 && Object.assign(n2.sidValuesMap, l2);
}
function N(e2, { scope: t2, safe: n2 } = {}) {
  r(t2 || Ke || n2, "scopeBind cannot be called outside of forked .watch");
  let a2 = t2 || Ke;
  return ee(e2) ? (t3) => {
    let r2 = g();
    return i({ target: e2, params: { params: t3, req: r2 }, scope: a2 }), r2.req;
  } : (t3) => (i({ target: e2, params: t3, scope: a2 }), t3);
}
function O(t2, n2 = {}) {
  t2.warnSerialize && console.error("There is a store without sid in this scope, its value is omitted");
  let a2 = n2.ignore ? n2.ignore.map(({ sid: e2 }) => e2) : [], i2 = {};
  return e(t2.sidValuesMap, (e2, r2) => {
    if (ae(a2, r2))
      return;
    let n3 = t2.sidIdMap[r2];
    i2[r2] = (t2.sidSerializeMap[r2] || Ot)(n3 && n3 in t2.reg ? t2.reg[n3].current : e2);
  }), "onlyChanges" in n2 && !n2.onlyChanges && (r(t2.cloneOf, "scope should be created from domain"), $(_(t2.cloneOf), (e2, r2) => {
    r2 in i2 || ae(a2, r2) || G(e2, "isCombine") || "ignore" === G(e2, "serialize") || (i2[r2] = t2.getState(e2));
  })), i2;
}
function F({ unit: e2, fn: t2, scope: r2 }) {
  let n2 = [Ee.run({ fn: (e3) => t2(e3) })];
  if (r2) {
    let t3 = a({ node: n2 }), i2 = e2.graphite.id, o2 = r2.additionalLinks, l2 = o2[i2] || [];
    return o2[i2] = l2, l2.push(t3), D(() => {
      let e3 = l2.indexOf(t3);
      -1 !== e3 && l2.splice(e3, 1), ct(t3);
    });
  }
  {
    let t3 = a({ node: n2, parent: [e2], family: { owners: e2 } });
    return D(() => {
      ct(t3);
    });
  }
}
function D(e2) {
  let t2 = () => e2();
  return t2.unsubscribe = () => e2(), t2;
}
var E = "undefined" != typeof Symbol && Symbol.observable || "@@observable";
var R = "map";
var P = "stack";
var _ = (e2) => e2.graphite || e2;
var V = (e2) => e2.family.owners;
var L = (e2) => e2.family.links;
var T = (e2) => e2.stateRef;
var B = (e2) => e2.value;
var W = (e2) => e2.subscribers;
var H = (e2) => e2.parent;
var U = (e2) => e2.scope;
var G = (e2, t2) => _(e2).meta[t2];
var J = (e2, t2, r2) => _(e2).meta[t2] = r2;
var K = (e2) => e2.compositeName;
var Q = (e2) => (ve(e2) || be(e2)) && "kind" in e2;
var X = (e2) => (t2) => Q(t2) && t2.kind === e2;
var Y = X("store");
var Z = X("event");
var ee = X("effect");
var te = X("domain");
var re = X("scope");
var ne = { __proto__: null, unit: Q, store: Y, event: Z, effect: ee, domain: te, scope: re, attached: (e2) => ee(e2) && 1 == G(e2, "attached") };
var ae = (e2, t2) => e2.includes(t2);
var ie = (e2, t2) => {
  let r2 = e2.indexOf(t2);
  -1 !== r2 && e2.splice(r2, 1);
};
var oe = (e2, t2) => e2.push(t2);
var le = (e2, t2, r2) => !e2 && console.error(`${t2} is deprecated${r2 ? `, use ${r2} instead` : ""}`);
var se = () => {
  let e2 = 0;
  return () => "" + ++e2;
};
var fe = se();
var ue = se();
var de = se();
var ce = null;
var pe = () => ce && ce.template;
var me = (e2) => (e2 && ce && ce.sidRoot && (e2 = `${ce.sidRoot}|${e2}`), e2);
var ge = ({ sid: e2, name: t2, loc: r2, method: i2, fn: o2 }) => n(a({ meta: { sidRoot: me(e2), name: t2, loc: r2, method: i2 } }), o2);
var he = (e2, r2) => {
  let n2 = _(e2);
  t(r2, (e3) => {
    let t2 = _(e3);
    "domain" !== n2.family.type && (t2.family.type = "crosslink"), oe(V(t2), n2), oe(L(n2), t2);
  });
};
var ye = (e2 = []) => (Array.isArray(e2) ? e2 : [e2]).flat().map(_);
var be = (e2) => "object" == typeof e2 && null !== e2;
var ve = (e2) => "function" == typeof e2;
var ke = (e2) => void 0 === e2;
var we = (e2) => r(be(e2) || ve(e2), "expect first argument be an object");
var Se = (e2, t2, n2, a2) => r(!(!be(e2) && !ve(e2) || !("family" in e2) && !("graphite" in e2)), `${t2}: expect ${n2} to be a unit (store, event or effect)${a2}`);
var xe = (e2, r2, n2) => {
  Array.isArray(e2) ? t(e2, (e3, t2) => Se(e3, r2, `${t2} item of ${n2}`, "")) : Se(e2, r2, n2, " or array of units");
};
var ze = (e2, r2, n2 = "target") => t(ye(r2), (t2) => le(!G(t2, "derived"), `${e2}: derived unit in "${n2}"`, "createEvent/createStore"));
var Me = (e2, { fn: t2 }, { a: r2 }) => t2(e2, r2);
var je = (e2, { fn: t2 }, { a: r2 }) => t2(r2, e2);
var Ce = (e2, { fn: t2 }) => t2(e2);
var $e = (e2, t2, r2, n2) => {
  let a2 = { id: ue(), type: e2, data: t2 };
  return r2 && (a2.order = { priority: r2 }, n2 && (a2.order.barrierID = ++Ae)), a2;
};
var Ae = 0;
var Ie = ({ from: e2 = "store", store: t2, target: r2, to: n2 = r2 ? "store" : P, batch: a2, priority: i2 }) => $e("mov", { from: e2, store: t2, to: n2, target: r2 }, i2, a2);
var qe = ({ fn: e2, batch: t2, priority: r2, safe: n2 = 0, filter: a2 = 0, pure: i2 = 0 }) => $e("compute", { fn: e2, safe: n2, filter: a2, pure: i2 }, r2, t2);
var Ne = ({ fn: e2 }) => qe({ fn: e2, priority: "effect" });
var Oe = (e2, t2, r2) => qe({ fn: e2, safe: 1, filter: t2, priority: r2 && "effect" });
var Fe = (e2, t2, r2) => Ie({ store: e2, to: t2 ? P : "a", priority: r2 && "sampler", batch: 1 });
var De = (e2 = Ce, t2) => qe({ fn: e2, pure: 1, filter: t2 });
var Ee = { mov: Ie, compute: qe, filter: ({ fn: e2, pure: t2 }) => qe({ fn: e2, filter: 1, pure: t2 }), run: Ne };
var Re = (e2) => ({ id: ue(), current: e2 });
var Pe = ({ current: e2 }) => e2;
var _e = (e2, t2) => {
  e2.before || (e2.before = []), oe(e2.before, t2);
};
var Ve = null;
var Le = (e2, t2) => {
  if (!e2)
    return t2;
  if (!t2)
    return e2;
  let r2;
  return (e2.v.type === t2.v.type && e2.v.id > t2.v.id || Ge(e2.v.type) > Ge(t2.v.type)) && (r2 = e2, e2 = t2, t2 = r2), r2 = Le(e2.r, t2), e2.r = e2.l, e2.l = r2, e2;
};
var Te = [];
var Be = 0;
for (; Be < 6; )
  oe(Te, { first: null, last: null, size: 0 }), Be += 1;
var We = () => {
  for (let e2 = 0; e2 < 6; e2++) {
    let t2 = Te[e2];
    if (t2.size > 0) {
      if (3 === e2 || 4 === e2) {
        t2.size -= 1;
        let e3 = Ve.v;
        return Ve = Le(Ve.l, Ve.r), e3;
      }
      1 === t2.size && (t2.last = null);
      let r2 = t2.first;
      return t2.first = r2.r, t2.size -= 1, r2.v;
    }
  }
};
var He = (e2, t2, r2, n2, a2, i2) => Ue(0, { a: null, b: null, node: r2, parent: n2, value: a2, page: t2, scope: i2 }, e2);
var Ue = (e2, t2, r2, n2 = 0) => {
  let a2 = Ge(r2), i2 = Te[a2], o2 = { v: { idx: e2, stack: t2, type: r2, id: n2 }, l: null, r: null };
  3 === a2 || 4 === a2 ? Ve = Le(Ve, o2) : (0 === i2.size ? i2.first = o2 : i2.last.r = o2, i2.last = o2), i2.size += 1;
};
var Ge = (e2) => {
  switch (e2) {
    case "child":
      return 0;
    case "pure":
      return 1;
    case "read":
      return 2;
    case "barrier":
      return 3;
    case "sampler":
      return 4;
    case "effect":
      return 5;
    default:
      return -1;
  }
};
var Je = /* @__PURE__ */ new Set();
var Ke;
var Qe = 1;
var Xe = 0;
var Ye = 0;
var Ze = null;
var et = (e2) => {
  Ke = e2;
};
var tt = (e2) => {
  Ze = e2;
};
var rt = (e2, t2) => {
  if (e2) {
    for (; e2 && !e2.reg[t2]; )
      e2 = H(e2);
    if (e2)
      return e2;
  }
  return null;
};
var nt = (e2, t2, r2, n2, a2) => {
  let i2 = rt(e2, n2.id);
  return i2 ? i2.reg[n2.id] : t2 ? (ot(t2, n2, a2), t2.reg[n2.id]) : n2;
};
var at = (e2) => e2;
var ot = (e2, r2, n2, a2, i2) => {
  var o2;
  let l2 = e2.reg, s2 = r2.sid, f2 = null == r2 || null === (o2 = r2.meta) || void 0 === o2 ? void 0 : o2.serialize;
  if (l2[r2.id])
    return;
  let u2 = { id: r2.id, current: r2.current, meta: r2.meta };
  if (s2 && s2 in e2.sidValuesMap && !(s2 in e2.sidIdMap))
    u2.current = (e2.fromSerialize && "ignore" !== f2 && (null == f2 ? void 0 : f2.read) || at)(e2.sidValuesMap[s2]);
  else if (r2.before && !i2) {
    let i3 = 0, o3 = n2 || !r2.noInit || a2;
    t(r2.before, (t2) => {
      switch (t2.type) {
        case R: {
          let r3 = t2.from;
          if (r3 || t2.fn) {
            r3 && ot(e2, r3, n2, a2);
            let i4 = r3 && l2[r3.id].current;
            o3 && (u2.current = t2.fn ? t2.fn(i4) : i4);
          }
          break;
        }
        case "field":
          i3 || (i3 = 1, u2.current = Array.isArray(u2.current) ? [...u2.current] : { ...u2.current }), ot(e2, t2.from, n2, a2), o3 && (u2.current[t2.field] = l2[l2[t2.from.id].id].current);
      }
    });
  }
  s2 && (e2.sidIdMap[s2] = r2.id), l2[r2.id] = u2;
};
var lt = (e2, t2, r2) => {
  try {
    return t2(B(r2), e2.scope, r2);
  } catch (t3) {
    console.error(t3), e2.fail = 1;
  }
};
var st = (t2, r2 = {}) => (be(t2) && (st(t2.or, r2), e(t2, (e2, t3) => {
  ke(e2) || "or" === t3 || "and" === t3 || (r2[t3] = e2);
}), st(t2.and, r2)), r2);
var ft = (e2, t2) => {
  ie(e2.next, t2), ie(V(e2), t2), ie(L(e2), t2);
};
var ut = (e2, t2, r2) => {
  let n2;
  e2.next.length = 0, e2.seq.length = 0, e2.scope = null;
  let a2 = L(e2);
  for (; n2 = a2.pop(); )
    ft(n2, e2), (t2 || r2 && "sample" !== G(e2, "op") || "crosslink" === n2.family.type) && ut(n2, t2, "on" !== G(n2, "op") && r2);
  for (a2 = V(e2); n2 = a2.pop(); )
    ft(n2, e2), r2 && "crosslink" === n2.family.type && ut(n2, t2, "on" !== G(n2, "op") && r2);
};
var dt = (e2) => e2.clear();
var ct = (e2, { deep: t2 } = {}) => {
  let r2 = 0;
  if (e2.ownerSet && e2.ownerSet.delete(e2), Y(e2))
    dt(W(e2));
  else if (te(e2)) {
    r2 = 1;
    let t3 = e2.history;
    dt(t3.events), dt(t3.effects), dt(t3.stores), dt(t3.domains);
  }
  ut(_(e2), !!t2, r2);
};
var pt = (e2) => {
  let t2 = () => ct(e2);
  return t2.unsubscribe = t2, t2;
};
var mt = (e2, t2, r2, n2, i2) => a({ node: r2, parent: e2, child: t2, scope: { fn: i2 }, meta: { op: n2 }, family: { owners: [e2, t2], links: t2 }, regional: 1 });
var gt = (e2) => {
  let t2 = "forward", [{ from: r2, to: n2 }, i2] = f(e2, 1);
  return xe(r2, t2, '"from"'), xe(n2, t2, '"to"'), ze(t2, n2, "to"), pt(a({ parent: r2, child: n2, meta: { op: t2, config: i2 }, family: {}, regional: 1 }));
};
var ht = (e2, t2) => (r(ve(t2), ".watch argument should be a function"), pt(a({ scope: { fn: t2 }, node: [Ne({ fn: Ce })], parent: e2, meta: { op: "watch" }, family: { owners: e2 }, regional: 1 })));
var yt = (e2, t2, r2 = "event") => {
  H(e2) && H(e2).hooks[r2](t2);
};
var bt = (e2, t2, r2) => {
  let n2 = st(r2), a2 = "domain" === e2, i2 = fe(), { sid: o2 = null, named: l2 = null, domain: f2 = null, parent: u2 = f2 } = n2, d2 = l2 || n2.name || (a2 ? "" : i2), c2 = s(d2, u2), p2 = { op: t2.kind = e2, name: t2.shortName = d2, sid: t2.sid = me(o2), named: l2, unitId: t2.id = i2, serialize: n2.serialize, derived: n2.derived, config: n2 };
  if (t2.parent = u2, t2.compositeName = c2, t2.defaultConfig = n2, t2.thru = (e3) => (le(0, "thru", "js pipe"), e3(t2)), t2.getType = () => c2.fullName, !a2) {
    t2.subscribe = (e4) => (we(e4), t2.watch(ve(e4) ? e4 : (t3) => e4.next && e4.next(t3))), t2[E] = () => t2;
    let e3 = pe();
    e3 && (p2.nativeTemplate = e3);
  }
  return p2;
};
var vt = (e2, t2, r2, n2) => {
  let a2;
  be(r2) && (a2 = r2, r2 = r2.fn);
  let i2 = d({ name: `${e2.shortName} \u2192 *`, derived: 1, and: a2 });
  return mt(e2, i2, n2, t2, r2), i2;
};
var kt = (e2, t2, r2, n2, a2) => {
  let i2 = T(t2), o2 = Ie({ store: i2, to: "a", priority: "read" });
  r2 === R && (o2.data.softRead = 1);
  let l2 = [o2, De(n2)];
  return u("storeOnMap", i2, l2, Y(e2) && T(e2)), mt(e2, t2, l2, r2, a2);
};
var wt = (t2, n2, a2, i2, l2) => {
  let s2 = t2 ? (e2) => [...e2] : (e2) => ({ ...e2 }), f2 = t2 ? [] : {}, d2 = s2(f2), p2 = Re(d2), m2 = Re(1);
  p2.type = t2 ? "list" : "shape", p2.noInit = 1, u("combineBase", p2, m2);
  let g2 = c(d2, { name: o(a2), derived: 1, and: i2 }), h2 = T(g2);
  h2.noInit = 1, J(g2, "isCombine", 1);
  let y2 = Fe(p2);
  y2.order = { priority: "barrier" };
  let b2 = [Oe((e2, t3, r2) => (r2.scope && !r2.scope.reg[p2.id] && (r2.c = 1), e2)), y2, Ie({ store: m2, to: "b" }), Oe((e2, { key: t3 }, r2) => {
    if (r2.c || e2 !== r2.a[t3])
      return n2 && r2.b && (r2.a = s2(r2.a)), r2.a[t3] = e2, 1;
  }, 1), Ie({ from: "a", target: p2 }), Ie({ from: "value", store: 0, target: m2 }), Ie({ from: "value", store: 1, target: m2, priority: "barrier", batch: 1 }), Fe(p2, 1), l2 && De()];
  return e(a2, (e2, t3) => {
    if (!Y(e2))
      return r(!Q(e2) && !ke(e2), `combine expects a store in a field ${t3}`), void (d2[t3] = f2[t3] = e2);
    f2[t3] = e2.defaultState, d2[t3] = e2.getState();
    let n3 = mt(e2, g2, b2, "combine", l2);
    n3.scope.key = t3;
    let a3 = T(e2);
    _e(p2, { type: "field", field: t3, from: a3 }), u("combineField", a3, n3);
  }), g2.defaultShape = a2, _e(h2, { type: R, from: p2, fn: l2 }), pe() || (g2.defaultState = l2 ? h2.current = l2(d2) : f2), g2;
};
var St = (e2, t2, r2) => {
  try {
    return [1, e2(...r2)];
  } catch (e3) {
    return t2(e3), [0, null];
  }
};
var xt = (e2) => {
  let t2 = U(e2), r2 = { ref: t2 };
  return t2 && oe(t2.activeEffects, r2), r2;
};
var zt = (e2, t2, r2, n2, a2, o2) => (l2) => {
  o2.ref && ie(o2.ref.activeEffects, o2), i({ target: [n2, Mt], params: [r2 ? { status: "done", params: e2, result: l2 } : { status: "fail", params: e2, error: l2 }, { value: l2, fn: r2 ? t2.rs : t2.rj }], defer: 1, page: a2.page, scope: o2.ref });
};
var Mt = a({ node: [Ne({ fn: ({ fn: e2, value: t2 }) => e2(t2) })], meta: { op: "fx", fx: "sidechain" } });
var jt = ["source", "clock", "target"];
var Ct = (e2, t2) => e2 + `: ${t2} should be defined`;
var $t = (e2, t2, n2, a2, i2, o2, l2, s2, f2, m2, g2, h2) => {
  let y2 = !!i2;
  r(!ke(n2) || !ke(t2), Ct(e2, "either source or clock"));
  let b2 = 0;
  ke(n2) ? b2 = 1 : Q(n2) || (n2 = p(n2)), ke(t2) ? t2 = n2 : (xe(t2, e2, "clock"), Array.isArray(t2) && (t2 = w(t2))), b2 && (n2 = t2), s2 || l2 || (l2 = n2.shortName);
  let v2 = "none";
  (g2 || a2) && (Q(a2) ? v2 = "unit" : (r(ve(a2), "`filter` should be function or unit"), v2 = "fn")), i2 ? (xe(i2, e2, "target"), ze(e2, i2)) : "none" === v2 && m2 && Y(n2) && Y(t2) ? i2 = c(o2 ? o2(Pe(T(n2)), Pe(T(t2))) : Pe(T(n2)), { name: l2, sid: h2, or: s2 }) : (i2 = d({ name: l2, derived: 1, or: s2 }), u("sampleTarget", _(i2)));
  let k2 = Re(), S2 = [];
  if ("unit" === v2) {
    let [r2, n3] = It(a2, i2, t2, k2, e2);
    S2 = [...At(n3), ...At(r2)];
  }
  let [x2, z2] = It(n2, i2, t2, k2, e2), M2 = mt(t2, i2, [u("sampleSourceLoader"), Ie({ from: P, target: k2 }), ...At(z2), Fe(x2, 1, f2), ...S2, Fe(k2), "fn" === v2 && De((e3, t3, { a: r2 }) => a2(e3, r2), 1), o2 && De(Me), u("sampleSourceUpward", y2)], e2, o2);
  return he(n2, [M2]), Object.assign(M2.meta, s2, { joint: 1 }), i2;
};
var At = (e2) => [Fe(e2), Oe((e3, t2, { a: r2 }) => r2, 1)];
var It = (e2, t2, r2, n2, i2) => {
  let o2 = Y(e2), l2 = o2 ? T(e2) : Re(), s2 = Re(o2);
  return o2 || a({ parent: e2, node: [Ie({ from: P, target: l2 }), Ie({ from: "value", store: 1, target: s2 })], family: { owners: [e2, t2, r2], links: t2 }, meta: { op: i2 }, regional: 1 }), u("sampleSource", s2, l2, n2), [l2, s2];
};
var qt = (e2, t2, r2, n2) => {
  let a2 = e2[t2];
  a2 && i({ target: a2, params: Array.isArray(a2) ? a2.map(() => r2) : r2, defer: 1, stack: n2 });
};
var Nt = "22.4.0";
var Ot = (e2) => e2;

export {
  n,
  a,
  i,
  l,
  d,
  c,
  p,
  m,
  h,
  y,
  b,
  v,
  k,
  w,
  x,
  z,
  M,
  j,
  C,
  I,
  q,
  N,
  O,
  F,
  ne,
  ge,
  Ee,
  ct,
  gt,
  Nt
};
//# sourceMappingURL=chunk-R4FTT3DN.js.map
